import { render, staticRenderFns } from "./BuscadorFichaTotales.vue?vue&type=template&id=5b8cf66b&"
import script from "./BuscadorFichaTotales.vue?vue&type=script&lang=js&"
export * from "./BuscadorFichaTotales.vue?vue&type=script&lang=js&"
import style0 from "./BuscadorFichaTotales.vue?vue&type=style&index=0&id=5b8cf66b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports